<script setup lang="ts"></script>

<template>
  <div class="mb-8">
    <h1 class="flex flex-wrap items-center justify-center">
      <span class="text-white text-2xl font-bold leading-none mb-1 sm:text-3xl">
        ApostaTudo:
      </span>

      <span class="w-full flex justify-center">
        <span
          class="text-white/60 text-xs text-center font-bold w-[14.5rem] block sm:w-full sm:text-sm"
        >
          Cassino Online Autorizado — Slots, Roleta e Jogos ao Vivo
        </span>
      </span>

      <span
        class="order-first flex rounded-full w-8 h-8 sm:w-10 sm:h-10 items-center justify-center border-2 border-white/60 border-solid flex-shrink-0 mr-1"
      >
        <ApLogoIcon class="w-full h-full" />
      </span>
    </h1>
  </div>
</template>
